import HttpService from './HttpService'

const _http = new HttpService()
export default {
  show: (page, search = null) => {
    let _parans = `?page=${page - 1}&asc`;
    if (search) {
      _parans += `&search=${search}`;
    }
    return _http.get(`/api/destiny-send${_parans}`)
  },  
  find: (id) => {
    return _http.get(`/api/destiny-send/${id}`)
  },
  create: (payload) => {
    return _http.post('/api/destiny-send', payload)
  },
  update: (payload) => {
    return _http.put('/api/destiny-send', payload)
  },
  delete: (id) => {
    return _http.delete(`/api/destiny-send/${id}`)
  }  
}